export enum PAGEPARTS {
    COVER = 'cover',
    INFO = 'info',
    REFERENCES = 'references',
    CONTACTS = 'contact',
    TEAM = 'team',
    PRIVACY = 'privacy-policy',
    IMPRESSUM = 'impressum',
    BLOG = 'blog'
}